import type { FunctionComponent } from 'react';
import ProductsList from '../../Orders/ProductsList';
import { getItemsCount, getSaleTypes } from '../../utils/orders';
import CollapsibleBar from '../CollapsibleBar';

type OrderProps = {
  order: {
    billingDate: string;
    orderTotalInCents: number;
    shippingAddress: Record<string, unknown>;
    shipments: Record<string, unknown>[];
  };
  index: number;
  isDesktop: boolean;
  onClickOrderDetails: (order: Record<string, unknown>) => void;
  trackOrderViewed: (order: Record<string, unknown>, index: number) => void;
  trackShipment: () => void;
};

const Order: FunctionComponent<OrderProps> = ({
  order,
  index,
  isDesktop,
  onClickOrderDetails,
  trackOrderViewed,
  trackShipment,
}) => {
  const { billingDate, orderTotalInCents, shippingAddress, shipments } = order;
  const saleType = getSaleTypes(shipments);
  const header = {
    saleType,
    billingDate,
    items: getItemsCount(shipments),
    orderTotal: orderTotalInCents / 100,
    shippingAddress,
  };
  const handleTrackOrderViewed = () => trackOrderViewed(order, index + 1);
  const handleClickOrderHeader = () => {
    if (!isDesktop) {
      onClickOrderDetails(order);
      handleTrackOrderViewed();
    }
  };

  return (
    <CollapsibleBar
      openOnLoad={index === 0 || !isDesktop}
      header={header}
      isDesktop={isDesktop}
      onClickOrderHeader={handleClickOrderHeader}
      trackOrderViewed={handleTrackOrderViewed}
    >
      <ProductsList order={order} isDesktop={isDesktop} trackShipment={trackShipment} />
    </CollapsibleBar>
  );
};

export default Order;
